/* ============================================================
   TALU Cart Drawer — F6-FIX-7
   Conecta el drawer premium del landing con Shopify cart.js
   ============================================================ */
(function() {
  'use strict';

  const FREE_SHIP_AT = parseInt(window.TALU_FREE_SHIP_AT || 25000, 10);
  const ROUTES = window.TALU_ROUTES || {
    cart: '/cart',
    cart_add: '/cart/add.js',
    cart_change: '/cart/change.js',
    cart_read: '/cart.js'
  };

  // FIX CONSOLIDADO: restaurar declaración (F6-FIX-12 eliminó por error la línea completa al quitar openBtn)
  let drawer, overlay, toast, body;
  let isOpen = false;
  let toastTimer;

  function fmt(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  // Intercept <a> links to cart (landing-style PDPs with target="_blank")
  function bindAddToCartLinks() {
    document.addEventListener('click', async (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      const cleanHref = href.replace(/^https?:\/\/[^\/]+/, '');
      const addMatch = cleanHref.match(/^\/cart\/add\?(?:.*&)?id=(\d+)(?:.*&quantity=(\d+))?/);
      const shortMatch = cleanHref.match(/^\/cart\/(\d+):(\d+)$/);
      let variantId, qty;
      if (addMatch) {
        variantId = addMatch[1];
        qty = parseInt(addMatch[2] || '1', 10);
      } else if (shortMatch) {
        variantId = shortMatch[1];
        qty = parseInt(shortMatch[2] || '1', 10);
      } else {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      try {
        const added = await addItem(variantId, qty);
        await refreshDrawer();
        openDrawer();
        showToast((added && added.product_title ? added.product_title : 'Producto') + ' agregado');
      } catch (err) {
        console.error('[TALU drawer] error al agregar desde link:', err);
        showToast((err && err.message) || 'No se pudo agregar');
      }
    });
  }

  // Limpiar links cart: quitar target=_blank y URLs absolutas — corre al init y por cada mutation del DOM
  function cleanCartLinks(root) {
    // Limpiar tambien <a> con target=_blank que apunten a /products/ (cards home + related)
    (root || document).querySelectorAll('a[target="_blank"][href*="/products/"]').forEach(a => {
      a.removeAttribute('target');
      a.removeAttribute('rel');
      // URLs absolutas -> relativas
      var href = a.getAttribute('href');
      if (href && href.indexOf('//') !== -1) {
        try {
          var u = new URL(href);
          a.setAttribute('href', u.pathname + u.search + u.hash);
        } catch (e) {}
      }
    });
    root = root || document;
    root.querySelectorAll('a[href*="/cart/"]').forEach(link => {
      link.removeAttribute('target');
      link.removeAttribute('rel');
      const href = link.getAttribute('href');
      if (href && href.match(/^https?:\/\/[^\/]+\/cart\//)) {
        link.setAttribute('href', href.replace(/^https?:\/\/[^\/]+/, ''));
      }
    });
  }

  function init() {
    drawer = document.querySelector('.cart-drawer-talu');
    overlay = document.querySelector('.cart-drawer-overlay');
    toast = document.querySelector('.cart-drawer-toast');
    body = document.body;

    if (!drawer) {
      console.warn('[TALU drawer] snippet cart-drawer-talu no encontrado');
      return;
    }

    bindOpenTriggers();
    bindCloseTriggers();
    bindNudgeClose();
    bindItemActions();
    bindUpsellActions();
    bindAddToCartForms();
    bindAddToCartLinks();
    cleanCartLinks();

    // Mutation observer: re-clean links cuando algo se inyecta al DOM
    try {
      const obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (node.nodeType === 1) cleanCartLinks(node);
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    bindCheckout();

    // F6-FIX-13 + PERF-1 (2026-05-21): originalmente forzábamos refreshDrawer() en init
    // para sincronizar HTML del snippet liquid. Optimización: ahora lazy — solo refresh
    // cuando el drawer se abre por primera vez (ahorra 518ms en page load del fetch /cart.js).
    // Si el snippet liquid render es problemático, descomenta el siguiente:
    // refreshDrawer().catch(function(err){ console.warn('[TALU drawer] init refresh failed:', err); });
  }

  function bindOpenTriggers() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) {
        e.preventDefault();
        openDrawer();
      }
    });
  }

  let _firstOpen = true;
  function openDrawer() {
    drawer.classList.remove('closed');
    if (overlay) overlay.classList.add('open');
    body.style.overflow = 'hidden';
    isOpen = true;
    // PERF-1: refresh lazy en primer abre (no en page load)
    if (_firstOpen) {
      _firstOpen = false;
      refreshDrawer().catch(function(err){ console.warn('[TALU drawer] lazy refresh failed:', err); });
    }
  }

  function bindCloseTriggers() {
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('.drawer-close')) closeDrawer();
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });
  }

  function closeDrawer() {
    drawer.classList.add('closed');
    if (overlay) overlay.classList.remove('open');
    body.style.overflow = '';
    isOpen = false;
  }

  async function fetchCart() {
    const r = await fetch(ROUTES.cart_read, { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  async function addItem(variantId, qty) {
    const r = await fetch(ROUTES.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || 'No se pudo agregar al carrito');
    }
    return r.json();
  }

  async function changeItem(key, qty) {
    const r = await fetch(ROUTES.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return r.json();
  }

  async function refreshDrawer() {
    const cart = await fetchCart();
    renderItems(cart);
    renderTotals(cart);
    renderHeader(cart);
    updateBadge(cart);
    renderNudge(cart);
  }

  // Nudge "te faltan $X": burbuja bajo la barra con sugerencia clickeable para cruzar el umbral
  function renderNudge(cart) {
    const nudge = drawer.querySelector('.freeship-nudge');
    if (!nudge) return;
    const freeShip = cart.total_price >= FREE_SHIP_AT * 100;
    let dismissed = false;
    try { dismissed = sessionStorage.getItem('taluNudgeOff') === '1'; } catch (e) {}
    if (freeShip || cart.item_count === 0 || dismissed) {
      nudge.hidden = true;
      return;
    }
    const needs = FREE_SHIP_AT * 100 - cart.total_price;
    const inCart = new Set(cart.items.map(i => String(i.variant_id)));
    const pool = (window.TALU_NUDGE || [])
      .filter(p => !inCart.has(String(p.variantId)))
      .sort((a, b) => a.price - b.price);
    const pick = pool.find(p => p.price >= needs) || pool[pool.length - 1];
    nudge.querySelector('.nudge-text').innerHTML =
      'Te faltan solo <b>' + fmt(needs) + '</b> para tu envío gratis 🚚';
    const btn = nudge.querySelector('.nudge-add');
    if (pick) {
      btn.hidden = false;
      btn.dataset.addVariant = pick.variantId;
      btn.textContent = '+ Agregar ' + pick.title + ' · ' + fmt(pick.price);
    } else {
      btn.hidden = true;
    }
    nudge.hidden = false;
    nudge.classList.remove('pop');
    void nudge.offsetWidth;
    nudge.classList.add('pop');
  }

  function bindNudgeClose() {
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('.nudge-close')) {
        try { sessionStorage.setItem('taluNudgeOff', '1'); } catch (err) {}
        const nudge = drawer.querySelector('.freeship-nudge');
        if (nudge) nudge.hidden = true;
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shortenTitle(t) {
    if (!t) return '';
    return t.length > 24 ? t.substring(0, 23) + '…' : t;
  }
  function renderItems(cart) {
    const container = drawer.querySelector('.cart-items');
    if (!container) return;
    if (cart.items.length === 0) {
      container.innerHTML =
        '<div class="cart-empty">' +
          '<div class="empty-icon">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4">' +
              '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
              '<line x1="3" y1="6" x2="21" y2="6"/>' +
              '<path d="M16 10a4 4 0 01-8 0"/>' +
            '</svg>' +
          '</div>' +
          '<p class="empty-title">Aún no agregaste nada</p>' +
          '<a href="/" class="empty-cta">Explorar productos</a>' +
        '</div>';
      return;
    }
    container.innerHTML = cart.items.map((item, idx) => {
      const title = item.product_title || '';
      const shortTitle = escapeHtml(shortenTitle(title));
      const fullTitle = escapeHtml(title);
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const imgUrl = (item.featured_image && item.featured_image.url) || item.image || '';
      const url = item.url || '/cart';
      return `
      <article class="cart-item" data-key="${item.key}" style="animation-delay:${idx * 0.08}s">
        <a href="${url}" class="item-img"><img src="${imgUrl}" alt="${fullTitle}" loading="lazy"></a>
        <div class="item-info">
          <h4 title="${fullTitle}">${shortTitle}</h4>
          ${variant ? `<div class="item-meta">${escapeHtml(variant)}</div>` : ''}
          <div class="item-qty">
            <button type="button" data-act="minus" aria-label="Restar">−</button>
            <span class="qty">${item.quantity}</span>
            <button type="button" data-act="plus" aria-label="Sumar">+</button>
          </div>
        </div>
        <div class="item-right">
          <div class="item-price">${fmt(item.final_line_price)}</div>
          <button type="button" class="item-remove" aria-label="Quitar">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14H7L5 6"/><path d="M10 11v6M14 11v6"/></svg>
          </button>
        </div>
      </article>
    `;
    }).join('');
  }

  function renderTotals(cart) {
    const totalEl = drawer.querySelector('.totals .amt');
    const shipNote = drawer.querySelector('.ship-note');
    const progressFill = drawer.querySelector('.progress-fill');
    const progressWrap = drawer.querySelector('.progress-wrap');
    const progressMsg = drawer.querySelector('.progress-label .msg');
    if (totalEl) totalEl.textContent = fmt(cart.total_price);
    document.querySelectorAll('[data-talu-shipping-status]').forEach(function(label){
      label.textContent=cart.total_price>=FREE_SHIP_AT*100
        ? 'Ya alcanzaste el mínimo de envío gratis'
        : cart.item_count>0
          ? 'Te faltan '+fmt(FREE_SHIP_AT*100-cart.total_price)+' para envío gratis'
          : 'Envío gratis desde '+fmt(FREE_SHIP_AT*100);
    });
    var savings=drawer.querySelector('[data-cart-savings]');
    if(!savings){
      savings=document.createElement('p');
      savings.setAttribute('data-cart-savings','');
      savings.style.cssText='font-size:13px;margin:8px 0;color:#6b5125';
      drawer.querySelector('.totals').prepend(savings);
    }
    var saved=Math.max(0,cart.original_total_price-cart.total_price);
    savings.hidden=saved===0;
    savings.textContent=saved?'Ahorras '+fmt(saved)+' con los descuentos aplicados':'';

    const freeShip = cart.total_price >= FREE_SHIP_AT * 100;
    if (shipNote) {
      if (freeShip) {
        shipNote.innerHTML = '<span class="check">✓</span> Mínimo para envío gratis alcanzado';
        shipNote.classList.add('free');
      } else {
        shipNote.textContent = 'Envío desde $3.150 (Santiago) · condiciones según destino';
        shipNote.classList.remove('free');
      }
    }
    const pct = Math.min(100, Math.round((cart.total_price / 100) / FREE_SHIP_AT * 100));
    if (progressFill) {
      // Web Animations API: no depende de CSS transition ni reflow tricks
      progressFill.style.width = pct + '%';
      try {
        progressFill.animate(
          [{ width: '0%' }, { width: pct + '%' }],
          { duration: 1100, easing: 'cubic-bezier(.22,.7,.2,1)', fill: 'forwards' }
        );
      } catch(e) { /* fallback: width inline ya aplicado */ }
    }
    if (progressWrap) {
      const wasUnlocked = progressWrap.classList.contains('unlocked');
      if (freeShip) {
        progressWrap.classList.add('unlocked');
        // Trigger pulse animation solo cuando se desbloquea recien (transicion)
        if (!wasUnlocked) {
          progressWrap.classList.remove('just-unlocked');
          void progressWrap.offsetWidth; // reflow
          progressWrap.classList.add('just-unlocked');
        }
      } else {
        progressWrap.classList.remove('unlocked');
        progressWrap.classList.remove('just-unlocked');
      }
    }
    if (progressMsg) {
      if (freeShip) {
        progressMsg.innerHTML = '<span class="check">✓</span> Mínimo para envío gratis alcanzado';
      } else {
        const need = FREE_SHIP_AT * 100 - cart.total_price;
        progressMsg.innerHTML = 'Te faltan <b>' + fmt(need) + '</b> para envío gratis';
      }
    }
  }

  function renderHeader(cart) {
    const eyebrow = drawer.querySelector('.drawer-head .eyebrow');
    if (eyebrow) {
      eyebrow.textContent = cart.item_count + ' producto' + (cart.item_count !== 1 ? 's' : '');
    }
  }

  function updateBadge(cart) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('visible', cart.item_count > 0);
    });
  }

  function bindItemActions() {
    drawer.addEventListener('click', async (e) => {
      const item = e.target.closest('.cart-item');
      if (!item) return;
      const key = item.dataset.key;
      if (!key) return;
      const qtyEl = item.querySelector('.qty');
      const currentQty = parseInt(qtyEl.textContent, 10);
      // closest() para que el click en el SVG (hijo del button) tambien se detecte
      const plusBtn = e.target.closest('[data-act="plus"]');
      const minusBtn = e.target.closest('[data-act="minus"]');
      const removeBtn = e.target.closest('.item-remove');
      if (plusBtn) {
        await changeItem(key, currentQty + 1);
        await refreshDrawer();
      } else if (minusBtn) {
        const newQty = Math.max(0, currentQty - 1);
        if (newQty === 0) await animateRemove(item);
        await changeItem(key, newQty);
        await refreshDrawer();
      } else if (removeBtn) {
        await animateRemove(item);
        await changeItem(key, 0);
        await refreshDrawer();
      }
    });
  }

  function animateRemove(item) {
    return new Promise(resolve => {
      item.style.transition = 'all .4s';
      item.style.opacity = '0';
      item.style.transform = 'translateX(40px)';
      setTimeout(resolve, 400);
    });
  }

  function bindUpsellActions() {
    drawer.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-variant]');
      if (!btn) return;
      const variantId = btn.dataset.addVariant;
      try {
        const added = await addItem(variantId, 1);
        await refreshDrawer();
        showToast(added.product_title + ' añadido');
      } catch (err) {
        showToast(err.message || 'Error al añadir');
      }
    });
  }

  function bindAddToCartForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const qty = parseInt(formData.get('quantity') || '1', 10);
      try {
        const added = await addItem(variantId, qty);
        await refreshDrawer();
        openDrawer();
        showToast(added.product_title + ' añadido');
      } catch (err) {
        showToast(err.message || 'No se pudo agregar');
      }
    });
  }

  function bindCheckout() {
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('.cta-pay')) {
        window.location.href = '/checkout';
      }
    });
  }

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
